// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListProjectsError-moduleerror__hMJDX";
var _2 = "GretaAIChatChatListProjectsError-moduletext__NoV2H";
export { _1 as "error", _2 as "text" }
